import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import pasImage from "../../../assets/images/vblog2.png"; // Update image accordingly
import ScrollToTopButton from "../../ScrollToTopButton";

const PublicSafety = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Public Awareness Through PAS Integration"
        breadcrumb={[
          { label: "Home", href: "/" },
          // { label: "Resources" },
          { label: "Blogs" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Public Awareness Through PAS Integration @ GyanYantram"
          shareUrl="https://yourdomain.com/blog/pas-integration"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-8 mb-10">
            <div className="lg:w-2/3">
              <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
                Summary
              </h4>
              <p className="text-black mb-4 text-lg">
                GyanYantram’s Public Address System (PAS) enables real-time voice
                announcements in crowded or emergency-prone areas. This technology
                is vital in disaster response, traffic control, and public events,
                ensuring fast, clear communication to the masses.
              </p>
              <p className="text-black text-lg">
                PAS provides authorities with instant outreach capabilities, boosting
                public safety and awareness during critical situations.
              </p>
            </div>
            <div className="lg:w-1/3">
              <img src={pasImage} alt="Public Address System" className="rounded-lg" />
              <p className="text-sm text-gray-500 mt-2 italic">
                Clear voice broadcasts via smart PAS technology
              </p>
            </div>
          </div>

          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Introduction
            </h4>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="md:col-span-2">
                <p className="text-black mb-4 text-lg">
                  In high-density areas, effective communication can mean the
                  difference between chaos and order. Traditional methods are
                  often slow and ineffective during emergencies.
                </p>
                <p className="text-black text-lg">
                  PAS offers a scalable solution by allowing administrators to
                  deliver announcements over loudspeakers instantly, minimizing panic
                  and guiding the public with clarity.
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-[#00D084]">
                <h5 className="font-bold text-lg mb-2">Did You Know?</h5>
                <p className="text-gray-700">
                  Cities with PAS infrastructure report up to 60% faster crowd control
                  during events and emergency evacuations.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-4 text-black">
              Key Features of PAS Integration:
            </h5>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-blue-500">
                  <h6 className="font-semibold text-lg mb-2">Real-Time Announcements</h6>
                  <p className="text-gray-700">
                    Broadcast live voice messages in seconds during emergencies or
                    crowded events.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-green-500">
                  <h6 className="font-semibold text-lg mb-2">Centralized Control</h6>
                  <p className="text-gray-700">
                    Manage and schedule announcements remotely through a unified dashboard.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-purple-500">
                  <h6 className="font-semibold text-lg mb-2">Clear Audio Delivery</h6>
                  <p className="text-gray-700">
                    High-quality sound ensures messages are heard clearly across large areas.
                  </p>
                </div>
              </div>
              <div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-red-500">
                  <h6 className="font-semibold text-lg mb-2">Integration with Sensors</h6>
                  <p className="text-gray-700">
                    Connect PAS to fire alarms, motion sensors, or emergency buttons for instant auto-broadcast.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-yellow-500">
                  <h6 className="font-semibold text-lg mb-2">Multi-Zone Coverage</h6>
                  <p className="text-gray-700">
                    Customize announcements to specific areas or broadcast citywide.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-indigo-500">
                  <h6 className="font-semibold text-lg mb-2">Energy Efficient</h6>
                  <p className="text-gray-700">
                    Designed with power-saving amplifiers and smart activation protocols.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-10 bg-gray-50 p-6 rounded-lg">
            <h5 className="text-xl font-semibold mb-4 text-black text-center">
              Impact of PAS on Public Safety
            </h5>
            <div className="grid md:grid-cols-3 gap-4">
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl font-bold text-[#00D084] mb-2">60%</div>
                <p className="text-gray-700">Faster evacuation during emergencies</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl font-bold text-[#00D084] mb-2">50%</div>
                <p className="text-gray-700">Improved traffic regulation at events</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl font-bold text-[#00D084] mb-2">75%</div>
                <p className="text-gray-700">Better disaster response communication</p>
              </div>
            </div>
          </div>

          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">Conclusion</h5>
            <div className="flex flex-col md:flex-row gap-6">
              <div className="md:w-2/3">
                <p className="text-black text-lg">
                  PAS by GyanYantram transforms the way authorities communicate
                  with the public during high-stress or high-attendance situations.
                  With the power of real-time, remote voice broadcasting, cities
                  become safer, more organized, and better prepared.
                </p>
              </div>
              <div className="md:w-1/3 bg-[#00D084] bg-opacity-10 p-4 rounded-lg">
                <h6 className="font-semibold text-lg mb-2">Looking Ahead</h6>
                <p className="text-gray-700">
                  Future upgrades may include AI-driven alerts, multilingual voice synthesis,
                  and predictive safety announcements.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-6 rounded-lg">
            <h5 className="text-xl font-semibold mb-3 text-black">
              GyanYantram’s Contribution
            </h5>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <p className="text-black mb-4 text-lg">
                  GyanYantram provides advanced PAS solutions tailored for urban and
                  institutional needs. With support for integration, remote management,
                  and robust hardware, their PAS systems help maintain order and ensure
                  safety.
                </p>
                <p className="text-black text-lg">
                  Learn more at{" "}
                  <a
                    href="https://gyanyantram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#00D084] hover:underline"
                  >
                    www.gyanyantram.com
                  </a>
                </p>
              </div>
              <div>
                <ul className="list-disc pl-6 space-y-2 text-lg text-black">
                  <li>
                    <strong>Real-Time Audio:</strong> Immediate, location-based voice broadcasts
                  </li>
                  <li>
                    <strong>Smart Integration:</strong> Connects with city sensors and alerts
                  </li>
                  <li>
                    <strong>Zone-Based Control:</strong> Custom audio per area or full coverage
                  </li>
                  <li>
                    <strong>Designed for Safety:</strong> Ideal for public events, metros, and campuses
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PublicSafety;
